// Support contact helpers (pure): placeholder rendering for the live preview + client-side validation that mirrors the API rules.

export const PLACEHOLDERS = ['screen_name', 'company', 'branch', 'status', 'screen_id', 'time'];

export const SAMPLE = {
  ar: { screen_name: 'شاشة البار', company: 'مقهى ركن الهيل', branch: 'فرع العليا', status: 'لا يوجد صوت منذ 14:12', screen_id: 'b2f1693dbf135de1', time: '14:30' },
  en: { screen_name: 'Bar screen', company: 'Rukn Al-Hail Café', branch: 'Olaya branch', status: 'No sound since 14:12', screen_id: 'b2f1693dbf135de1', time: '14:30' },
};

export const E164 = /^\+[1-9]\d{6,14}$/;
const CALL = /^\+?[0-9][0-9\s\-()]{4,30}$/;

export function renderTemplate(template, values) {
  return String(template ?? '').replace(/\{([^{}]*)\}/g, (m, name) => (PLACEHOLDERS.includes(name) ? String(values?.[name] ?? '') : m));
}

export function unknownPlaceholders(template) {
  const out = new Set();
  String(template ?? '').replace(/\{([^{}]*)\}/g, (m, name) => { if (!PLACEHOLDERS.includes(name)) out.add(name); return m; });
  return [...out];
}

/** @returns {{[field:string]:string}} empty object = valid. Empty fields are valid (they mean "use default"). */
export function validateSupport(f) {
  const e = {};
  if (f.whatsapp_e164 && !E164.test(f.whatsapp_e164.trim())) e.whatsapp_e164 = 'Use international format: + then country code and number, digits only (e.g. +966500000000).';
  if (f.call_number && !CALL.test(f.call_number.trim())) e.call_number = 'Enter a phone number (digits, spaces, +, -, parentheses).';
  for (const k of ['template_ar', 'template_en']) {
    const bad = unknownPlaceholders(f[k]);
    if (bad.length) e[k] = `Unknown placeholder${bad.length > 1 ? 's' : ''}: ${bad.map((b) => `{${b}}`).join(', ')}. Allowed: ${PLACEHOLDERS.map((p) => `{${p}}`).join(' ')}.`;
  }
  return e;
}

/** The wa.me link the customer page builds (shown in the preview so the admin sees the real target). */
export function waLink(e164, text) {
  const digits = String(e164 ?? '').replace(/\D/g, '');
  return digits ? `https://wa.me/${digits}?text=${encodeURIComponent(text)}` : null;
}
